import { Typography } from '@euler/app/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { View } from 'react-native';
import { TOKENS } from '../constants';

export const ModelBadge = memo(({ label }: { label: string }) => {
  const { rpx } = useResponsiveContext();
  return (
    <View
      css={`
        border-width: ${rpx(1)}px;
        border-color: ${TOKENS.modelBadgeBorder};
        border-radius: ${rpx(3)}px;
        padding: ${rpx(1)}px ${rpx(6)}px;
        margin-left: ${rpx(8)}px;
        justify-content: center;
      `}
    >
      <Typography.Label
        color={TOKENS.modelBadgeText}
        size={rpx(11)}
        lineHeight={rpx(15)}
        numberOfLines={1}
      >
        {label}
      </Typography.Label>
    </View>
  );
});
